import Axhelper from '@/lib/Axhelper'

class TablicaService {
	constructor() {
		this.endpoints = {
			colors: '/api/tablica/colors',
			trainers: '/api/uzytkownicy/filters',
		}
	}

	async getColors({ startDate, endDate }) {
		try {
			const params = new URLSearchParams({ startDate, endDate })
			const response = await Axhelper.sendGetAsync(`${this.endpoints.colors}?${params.toString()}`)
			if (response.error) {
				return { data: [], error: response.error }
			}
			return { data: Array.isArray(response.data) ? response.data : [], error: null }
		} catch (error) {
			console.error('TablicaService.getColors error:', error)
			return { data: [], error: error.message || 'Failed to load board colors' }
		}
	}

	async saveColor({ userId, date, color }) {
		try {
			const params = new URLSearchParams({
				userId,
				date,
				color: color || '',
			})
			const response = await Axhelper.sendPutAsync(this.endpoints.colors, params)
			if (response.error) {
				return { success: false, error: response.error }
			}
			return { success: true, error: null, data: response.data }
		} catch (error) {
			console.error('TablicaService.saveColor error:', error)
			return { success: false, error: error.message || 'Failed to save board color' }
		}
	}

	async getTrainers() {
		try {
			const params = new URLSearchParams({
				isTrainer: 'true',
				limit: '500',
				sortcol: 'nazwa',
				sortdir: 'asc',
			})
			const response = await Axhelper.sendGetAsync(`${this.endpoints.trainers}?${params.toString()}`)
			if (response.error) {
				return { data: [], error: response.error }
			}
			const rows = Array.isArray(response.data) ? response.data : []
			return {
				data: rows.filter(user => user?.isTrainer === true || user?.isTrainer === 'true'),
				error: null,
			}
		} catch (error) {
			console.error('TablicaService.getTrainers error:', error)
			return { data: [], error: error.message || 'Failed to load trainers' }
		}
	}
}

export default new TablicaService()
